module.exports = __webpack_public_path__ + "img/TBetMake_Logo-RGB-Hori-noTAG.0999e9fa.png";